import { PrivateLeaseStoreService } from '@hb/modules/financial-obligations/private-lease/private-lease-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { CO_QUESTION_KEY, GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'private-lease-amount',
    imports: [ApAmountInputComponent, AdditionalInfoComponent, ReactiveFormsModule, ApContentPipe, NextButtonComponent],
    templateUrl: './private-lease-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PrivateLeaseStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PRIVATE_LEASE_AMOUNT },
        { provide: CO_QUESTION_KEY, useValue: QuestionKey.PRIVATE_LEASE_AMOUNT_CO_APPLICANT }
    ]
})
export class PrivateLeaseAmountComponent extends GlobalInjectComponent<PrivateLeaseStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PrivateLeaseStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getMainApplicantMonthlyPayment()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setMainApplicantMonthlyPayment(amount));

        this.coApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getCoApplicantMonthlyPayment()?.amount.toString(),
            this.coQuestionKey
        );
        this.coApplicantControl.onUpdate().subscribe((amount) => this.store.setCoApplicantMonthlyPayment(amount));
    }
}
